<template>
	<select @change="$emit('update:modelValue', $event.target.value)">
		<slot/>
	</select>
</template>

<script>
export default {
	name: "GuestSelect",
	props: ["modelValue"],
}
</script>

<style scoped>
	select {
        outline: 0;
        background: #f2f2f2;
        width: 100%;
        border: 0;
        margin: 0 0 15px;
        padding: 15px;
        box-sizing: border-box;
        font-size: 14px;
		text-indent: 1px;
		text-overflow: '';
    }

</style>